import helpers from '../../helpers'
import httpService from '@/http'
import api from '../../api'
import { role } from '@/helpers/functions'

const mapper = helpers.mapper
const apiModule = api.bonuses

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    status: {
      data: 'status',
      title: 'Статус',
      value: null,
      type: null,
      order: null,
      showOrder: false
    },
    info: {
      data: 'info',
      title: 'Информация',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    price: {
      data: 'price',
      title: 'Цена',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    bonus: {
      data: 'bonus',
      title: 'Бонусы',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    payType: {
      data: 'payType',
      title: 'Тип оплаты',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    user: {
      data: 'userId',
      title: 'Клиент',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    updatedAt: {
      data: 'updatedAt',
      title: 'Дата',
      value: null,
      type: 'datetime',
      order: 'desc',
      showOrder: true
    }
  }
}

const state = {
  model: getModel(),
  show: 'bonuses',
  showFilters: false,
  isFilter: false,
  filtersQuery: {},
  questions: [],
  filters: {
    price: []
  }
}
const getters = {
  getModel: state => state.model,
  getShow: state => state.show,
  getShowFilters: state => state.showFilters,
  getAll: state => state.questions,
  getErrMain: state => state.errMain,
  getFiltersQuery: state => state.filtersQuery,
  getIsFilter: state => state.isFilter,
  getFilters: state => state.filters
}
const mutations = {
  setModel (state, data) {
    state.model = data
  },
  setShow (state, data) {
    state.show = data
  },
  setShowFilters (state, data) {
    state.showFilters = data
  },
  setErrMain (state, data) {
    state.errMain = data
  },
  setAll (state, data) {
    state.questions = data
  },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    }
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order === 'desc') order = 'asc'
    else if (order === 'asc') order = null
    state.model[data.param].order = order
  },
  setFiltersQuery (state, data) {
    state.filtersQuery = data
  },
  resetFiltersQuery (state) {
    state.filtersQuery = {}
  },
  setIsFilter (state, data) {
    state.isFilter = data
  },
  setFilters (state, data) {
    state.filters = data
  }
}
const actions = {
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  sendErrMain ({ commit }, data) {
    commit('setErrMain', httpService.error(data))
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      }
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAll, data.params);
      result.data.data.forEach((e) => {
        e.userId = e.user.phone
      })
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
  async getFilters ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(apiModule[role()].getFilters, data.params)
      commit('setFilters', result.data)
    } catch (err) {
      dispatch('sendErrMain', err)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
